import React, { useState } from "react";

// Standalone inline form component highlighted inside a bright yellow container
// Props:
//   onPublished?: () => void  - called after a successful publish (HTTP 201)
const VideoJobForm = ({ onPublished }) => {
	const [platform, setPlatform] = useState("");
	const [videoUrl, setVideoUrl] = useState("");
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!platform || !videoUrl) {
			alert("Por favor selecciona una plataforma e introduce la URL del video.");
			return;
		}

		const token = localStorage.getItem("cliperos_token");
		if (!token) {
			alert("Tu sesión ha expirado. Inicia sesión nuevamente.");
			return;
		}

		try {
			setSubmitting(true);
			const response = await fetch("https://nodeapi.juan1ondonolinks.com/api/videos/publish", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer ${token}`,
				},
				body: JSON.stringify({
					URL_Video: videoUrl,
					FK_Plataforma_Code: platform,
				}),
			});

			if (response.status !== 201) {
				const errorText = await response.text();
				console.error("Error response:", errorText);
				alert("No se pudo publicar el video. Intenta nuevamente.");
				return;
			}

			const data = await response.json();
			console.log("Video published:", data);
			alert("Video publicado correctamente.");
			setVideoUrl("");
			setPlatform("");
			if (typeof onPublished === "function") {
				onPublished();
			}
		} catch (err) {
			console.error(err);
			alert("No se pudo conectar con el servidor.");
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div className="video-job-wrapper">
			<form className="video-job-form-shell" onSubmit={handleSubmit}>
				{/* Plataforma dropdown */}
				<div className="video-job-field">
					<label className="video-job-label" htmlFor="platform">
						Plataforma
					</label>
					<div className="video-job-input-shell">
						<select
							id="platform"
							className="video-job-input"
							value={platform}
							onChange={(e) => setPlatform(e.target.value)}
						>
							<option value="" disabled>
								Seleccionar...
							</option>
							<option value="YT">Youtube</option>
							<option value="IG">Instagram</option>
							<option value="TIKTOK">TikTok</option>
						</select>
						
					</div>
				</div>

				{/* URL del Video text input */}
				<div className="video-job-field">
					<label className="video-job-label" htmlFor="videoUrl">
						URL del Video
					</label>
					<div className="video-job-input-shell video-job-input-shell--wide">
						<input
							id="videoUrl"
							className="video-job-input"
							placeholder="https://..."
							value={videoUrl}
							onChange={(e) => setVideoUrl(e.target.value)}
						/>
						
					</div>
				</div>

				{/* Submit button */}
					<button className="video-job-submit" type="submit" disabled={submitting}>
						{submitting ? "Enviando..." : "Enviar"}
					</button>
			</form>
		</div>
	);
};

export default VideoJobForm;
